import {Modal} from 'react-bootstrap'
import {KTIcon} from '../KTIcon'
import {FC} from 'react'

type props = {
  setServiceHelp: React.Dispatch<React.SetStateAction<boolean>>
}

const ServiceHelp: FC<props> = ({setServiceHelp}) => {
  const handleClose = () => {
    setServiceHelp(false)
  }
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
        show
        backdrop={true}
      >
        <div className='modal-header'>
          <h2>راهنمای کالا یا خدمات</h2>
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
            <KTIcon className='fs-1' iconName='cross' />
          </div>
        </div>
        <div className='modal-body py-lg-10 px-lg-10'></div>
      </Modal>
    </>
  )
}

export {ServiceHelp}
